import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Stack,
  CircularProgress,
  Typography,
  IconButton,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../auth/useAuth";
import { useNotification } from "../../../context/NotificationContext";

import { APP_API_V1_BASE } from "../../../config/api";
import { Close } from "@mui/icons-material";
const API_BASE = `${APP_API_V1_BASE}/organizations`;

export default function AddUserModal({
  open,
  onClose,
  orgId,
  onUserAdded,
  onInviteAdded,
}) {
  const { activeOrg } = useAuth();
  const { showNotification } = useNotification();

  const [email, setEmail] = useState("");
  const [role, setRole] = useState("viewer");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!email) {
      setError("Email is required");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("authToken");

      const res = await axios.post(
        `${API_BASE}/${orgId}/users`,
        { email, role },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            ...(activeOrg?.id ? { "X-Org-ID": activeOrg.id } : {}),
          },
        },
      );

      console.log(res.data, 56);

      if (res.data.status === "active") {
        onUserAdded({
          user_id: res.data.email,
          email,
          role,
          status: "active",
          name: email.split("@")[0],
        });
      } else {
        onInviteAdded({
          email,
          role,
          status: "pending",
          created_at: res.data.created_at,
          expires_at: res.data.expires_at,
        });
      }
      showNotification(
  res.data.status === "active"
    ? "User added successfully."
    : "Invitation sent successfully.",
  "success"
);

      setEmail("");
      setRole("viewer");
      onClose();
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to add user");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #0f172a, #0f766e 60%, #082f49)",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <Typography variant="h6" fontWeight={700}>Add User</Typography>
        <IconButton sx={{color: "#fff"}} onClick={onClose}>
          <Close/>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            required
          />

          <TextField
            label="Role"
            select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            fullWidth
          >
            <MenuItem value="org_admin">Org Admin</MenuItem>
            <MenuItem value="manager">Manager</MenuItem>
            <MenuItem value="operator">Operator</MenuItem>
            <MenuItem value="viewer">Viewer</MenuItem>
          </TextField>

          {error && (
            <Typography color="error" fontSize={14}>
              {error}
            </Typography>
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
          sx={{ background: "linear-gradient(135deg, #FDE68A, #F59E0B)" }}
        >
          {loading ? <CircularProgress size={20} /> : "Add User"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
